const PinIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.31999 10C9.37415 10 10.2367 9.1 10.2367 8C10.2367 6.9 9.37415 6 8.31999 6C7.26582 6 6.40332 6.9 6.40332 8C6.40332 9.1 7.26582 10 8.31999 10ZM8.31999 0C12.345 0 15.9867 3.22 15.9867 8.2C15.9867 11.38 13.6387 15.12 8.95249 19.43C8.58832 19.76 8.04207 19.76 7.6779 19.43C3.00124 15.12 0.65332 11.38 0.65332 8.2C0.65332 3.22 4.29499 0 8.31999 0Z"
        fill={color}
      />
    </svg>
  );
};

export default PinIcon;
